import axios from "axios";

export async function GetScenarios() {
  const response = await axios.get(`/api/v1.0/scenario/`);

  return response.data;
}

export async function UpdateScenarios(scenario) {
  const response = await axios.post(
    `/api/v1.0/scenario/${scenario.id}`,
    scenario,
    {
      validateStatus: function(status) {
        return true;
      }
    }
  );

  if (response.data.errorMessages && response.data.errorMessages.length > 0) {
    throw response.data;
  }

  return response.data;
}

export async function CreateScenarios(scenario) {
  const response = await axios.put(`/api/v1.0/scenario/`, scenario, {
    validateStatus: function(status) {
      return true;
    }
  });

  if (response.data.status >= 400) {
    throw response.data;
  }

  return response.data;
}
